module.exports = __webpack_public_path__ + "static/media/icon-t-sne.fddd3282.svg";